import React from 'react';
import PhotoshootGallery from '../components/photography/PhotoshootGallery';
import ContactForm from '../components/contact/ContactForm';
import SuccessModal from '../components/contact/SuccessModal';
import { useContact } from '../hooks/useContact';
import SEO from '../components/SEO';

const Photography = ({ siteData }) => {
    const {
        isContactFormOpen,
        isSuccessModalOpen,
        contactData,
        openContactForm,
        closeContactForm,
        handleContactSuccess,
        closeSuccessModal,
    } = useContact();
    return (
        <>
            <SEO
                title="Photography Portfolio | Savana Ashlea"
                description="Explore my photography portfolio capturing life's beautiful moments. From portraits to landscapes, discover stunning visual storytelling."
                url="https://savanashlea.com/photography"
                image="/photography-og.jpg"
            />
            <div className="pt-16 min-h-screen bg-white">
                <div className="py-12">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h1 className="text-4xl font-light text-gray-900 mb-4">
                            {siteData?.photography?.title || 'Photography Portfolio'}
                        </h1>
                        {isContactFormOpen && (
                            <ContactForm
                                inquiryType={contactData.inquiryType}
                                prefilledData={contactData.prefilledData}
                                onClose={closeContactForm}
                                onSuccess={handleContactSuccess}
                            />
                        )}

                        {isSuccessModalOpen && (
                            <SuccessModal onClose={closeSuccessModal} />
                        )}
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                            Capturing life's precious moments with artistic vision and professional excellence.
                        </p>
                        <button
                            onClick={() => openContactForm('photography')}
                            className="mt-8 bg-sage-600 text-white px-8 py-3 rounded-lg text-lg font-medium hover:bg-sage-700 transition-colors shadow-md hover:shadow-lg"
                        >
                            Book Your Session
                        </button>
                    </div>
                </div>

                <PhotoshootGallery photoshoots={siteData?.photography?.photoshoots || []} />
            </div>
        </>
    );
};

export default Photography;